import hoistStatics from 'hoist-non-react-statics';

export default function decorator(func) {
    return (...args) => Class => {
        let Decorated = func(...args)(Class); // eslint-disable-line prefer-const
        return hoistStatics(Decorated, Class);
    };
}
